export default {
  'otp:title': 'Введите код из SMS',
  'otp:text': '<span class="marked inline-flex mb-1">На телефон вашего ребенка</span> <br>На {0} отправлен SMS <br/>с кодом подтверждения.',
  'otp:timer': 'Отправить повторно через <span class="otp__timer-counter">{0}</span> сек',
  'otp:btn': 'Отправить повторно'
}
